var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgXTwitterIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.33189 5.92788L13.5436 0H12.3086L7.78334 5.14724L4.16895 0H0L5.46551 7.78344L0 14H1.23503L6.01378 8.56408L9.83105 14H14L8.33132 5.92788H8.33189ZM6.64016 7.85204L6.08646 7.077L1.68 0.90972H3.57719L7.1332 5.88672L7.68691 6.66176L12.3091 13.1314H10.4119L6.64016 7.85204Z",
  fill: "#4A148C"
})));
export default SvgXTwitterIcon;